module.exports = __webpack_public_path__ + "img/CellReports_YangRui_2024.5d314710.png";